import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";

interface NextGenSwitchPromptProps {
  /** Opt the user into the new experience so the linked page can render. */
  onConfirm: () => void;
  /** Dismiss without opting in (Escape, Cancel, or overlay) — falls back to 404. */
  onCancel: () => void;
}

/**
 * Shown when a user who is eligible for the new experience, but has not yet
 * opted in, follows a `/nova` link. Offers to switch them over rather than
 * dead-ending at a 404.
 */
export const NextGenSwitchPrompt = ({ onConfirm, onCancel }: NextGenSwitchPromptProps) => (
  <AlertDialog open onOpenChange={(open) => !open && onCancel()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Switch to the new experience?</AlertDialogTitle>
        <AlertDialogDescription>
          This link opens in the new experience, which you haven&apos;t turned on yet. Switch now to
          view it? You can switch back to the classic look anytime from the account menu.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Not now</AlertDialogCancel>
        <AlertDialogAction
          onClick={(e) => {
            e.preventDefault();
            onConfirm();
          }}
        >
          Switch
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
